import { ProductCard } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';

export interface ThumbnailCheckboxProps {
  onChange?: (isSelected: boolean) => void;
  isSelected: boolean;
}

export const ThumbnailCheckbox = ({ isSelected, onChange }: ThumbnailCheckboxProps) => {
  return (
    <>
      {isSelected && <ProductCard.ThumbnailDimmed backgroundColor={vars.color.onImageBlackOpacity30} />}
      <ProductCard.ThumbnailCheckbox ariaLabel='상품 선택' checked={isSelected} onChange={onChange} />
    </>
  );
};
